import { render, staticRenderFns } from "./OwnerProfile.vue?vue&type=template&id=68eef66a&"
import script from "./OwnerProfile.vue?vue&type=script&lang=js&"
export * from "./OwnerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports